<template>
  <div>
    <!-- Start Shop Area -->
    <section class="shop-area ptb-80">
      <div class="container">
        <div class="woocommerce-topbar">
          <div class="row align-items-center">
            <div v-if="v2" class="col-lg-9 col-md-7 col-sm-7">
              <div class="woocommerce-result-count">
                <p>Showing 1-8 of 14 results</p>
              </div>
            </div>

            <div v-if="v2" class="col-lg-3 col-md-5 col-sm-5">
              <div class="woocommerce-topbar-ordering">
                <select class="form-control">
                  <option value="1">Sort by Popularity</option>
                  <option value="2">Sort by Average Rating</option>
                  <option value="0">Sort by Latest</option>
                  <option value="3">Sort by price: Low to High</option>
                  <option value="4">Sort by price: High to Low</option>
                  <option value="5">Sort by New</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <product
            v-for="product in filteredProducts"
            :product="product"
            :key="product.id"
            @product-selected="handleProductSelected"
            @add-to-cart="handleAddToCart"
            @update-cart="handleUpdateCart"
            class="col-lg-3 col-md-6 col-sm-6"
          />

          <!-- Pagination -->
          <div v-if="v2" class="col-lg-12 col-md-12 col-sm-12">
            <div class="pagination-area">
              <nav aria-label="Page navigation">
                <ul class="pagination justify-content-center">
                  <li class="page-item">
                    <a class="page-link" href="#">Prev</a>
                  </li>
                  <li class="page-item active">
                    <a class="page-link" href="#">1</a>
                  </li>
                  <li class="page-item"><a class="page-link" href="#">2</a></li>
                  <li class="page-item"><a class="page-link" href="#">3</a></li>
                  <li class="page-item">
                    <a class="page-link" href="#">Next</a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Shop Area -->
  </div>
</template>

<script>
import Product from "../common/product";
export default {
  name: "StoreFront",
  components: {
    Product
  },
  props: {
    products: {
      type: Array,
      required: false,
      default: () => []
    },
    isManagementMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      cart: [],
      v2: false
    };
  },
  methods: {
    handleProductSelected(product) {
      this.$emit("product-selected", product);
    },
    handleAddToCart(product) {
      this.$emit("add-to-cart", product);
    },
    handleUpdateCart(product) {
      this.$emit("update-cart", product);
    },
    removeFromCart(product) {
      this.$emit("remove-from-cart", product);
    }
  },
  computed: {
    filteredProducts() {
      return this.products;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/style/style.scss";
</style>
